import Component from '../Component';
import { PostcardPinState } from '../../Prototype/World/PostcardPin';

export default class PostcardPinComponent extends Component {
    public place: number = undefined;
    public background: string = undefined;
    public state: PostcardPinState = undefined;
}
